import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

const ToastButton = ({ message, type }) => {
  const notify = () => {
    switch (type) {
      case 'success':
        toast.success(message);
        break;
      case 'error':
        toast.error(message);
        break;
      case 'loading':
        toast.loading(message);
        break;
      default:
        toast(message);
        break;
    }
  };

  return (
    <div>
      {/* Global toaster config for top-right */}
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#1e1e1e', // dark trading style
            color: '#fff',
            fontSize: '14px',
            borderRadius: '6px',
            padding: '8px 12px',
          },
        }}
      />
    </div>
  );
};

export default ToastButton;
